import {
  type
} from "os";

/**
 * 公共字段
 */

export const PRICE_UNIT = {
  RMB: '¥',
  HKD: 'HK$',
  integral: '積分',
}

//底部菜单
export const READER_TOOL_BAR_LANG = {
  progress: '本書進度',
  fontSize: '字體大小',
  fontText: '字體',
  catagoryText: '目錄',
  progressText: '進度',
  neoworkMessage: '當前網絡狀態不是wifi環境是否繼續下載',
  changeLanguage: '繁簡切換',
  down: {
    isDown: '已經下載過',
    noUserId: '缺少用戶id，無法下載，請重新登錄',
    startDown: '開始下載',
    noDownData: '缺少下載數據，退出電子書重新進入再試',
    downSuccess: '緩存成功',
    downing: '正在下載',
    downloading:"下載中",
    downloadNow:"立即下載",
    downloadTips:"當前下載使用WiFi",
    downloadTipsMobile:"當前下載使用數據流量",
    downloadTipsFile:"文件大小為",
    downloadTipsSuccess:"您已經下載了，請在離線閱讀中查看",
  },
  fontTypeChange:'字體選擇',
  fontType:{
    defaultFont:'默認字體',
    heiTi:'方正黑體',
    kaiTi:'方正楷體',
    shuSong:'方正書宋',
    fangSong:'方正仿宋',
    songTi:'思源宋體',
    sHeiTi:'思源黑體',
  }
}

export const READER_LANG = {
  buyMessage: '該內容需要購買才可繼續閱讀',
  downMessage: '該內容需要購買才可繼續下載',
  goBack: '返回第一章',
  changeEoobContent: '電子書內容已進行切換'
}

//目录菜单
export const CATAGORY_LANG = {
  menu: {
    catagory: '目錄',
    bookmark: '書籤',
    mark: '筆記',
  },
  note: {
    mark: '筆記',
    line: '劃線',
    dele: '刪除'
  },
  emptyNoteText: '閱讀時長按文本添加第一條筆記'
}

//划线菜单
export const MENU_LANG = {
  placeholder: '寫下這一刻想法',
  reference: '引用',
  mark: '筆記',
  line: '劃線',
  publicDialog: {
    title: '公開',
    text: '所有人可見'
  },
  privateDialog: {
    title: '私有',
    text: '僅自己可見'
  }
}

export const PAGE_HEADER_TITLE = {
  index: '知書',
  sayingBook: "講書",
  startCourse: "開課",
  audioBook: "有聲書",
  eBook: "電子書",
  ebookCatalogList: "電子書分類",
  videoList: "視頻",
  search: "搜尋",
  searchCatalog: "分類搜尋",
  detail: "詳情",
  audioDetail: "播放詳情",
  videoDetail: "視頻詳情",
  login: "登入",
  bindEmail: "綁定電郵",
  forget: "忘記密碼",
  register: "註冊",
  nickName: "設置稱謂",
  registerSuccess: "註冊成功",
  buy: "註冊成功",
  buySuccess: "購買成功",
  buyFail: '購買失敗',
  recharge: "增值",
  rechargeTips: "付款提示",
  andRecharge: "支付",
  rechargeList: "增值記錄",
  rechargeSuccess: "增值成功",
  purchase: "已購",
  personal: "個人資料",
  bindPhone: "綁定手機",
  collection: "收藏",
  historyRecordAudio: "聽過的書",
  historyRecordEbook: "看過的書",
  historyRecordCourse: "聽過的課",
  coupon: "優惠券",
  exchange: "兌換優惠券",
  exchangez: "充值卡",
  setting: "設置",
  about: "關於",
  feedback: "反饋",
  vip: "會員",
  ebookGuide: "電子書",
  ebookDetail: "電子書",
  comment: "留言",
  help: "幫助中心",
  advertising: "廣告合作",
  useTerms: '使用條款',
  policy: '隱私政策',
  memberArea: '會員專區',
  expensesRecord: "消費記錄",
  recordDetails: "消費詳情",
  memberInfo: "會員",
  vipDetails: "會籍詳情",
  supremeMember: "至尊會員",
  discount: "專享折扣",
  freeGoods: "專享免費",
  memberGift: "會員禮包",
  vipDetails2: "會籍詳情",
  signCalendar: "簽到",
  signDescription: "簽到規則",
  signGifts: "簽到禮包",
  flashSalesList: "限時閃購",
  flashSalesFree: "限時免費",
  flashSalesRead: '立刻閱讀',
  recommendSalesList: "精品推薦",
  giftPackDetail: "活動禮包",
  activityList: "促销活动",
  news: "消息",
  epubLocalList: '離線閱讀',
  testTile: '測一測',
  audioTest: '測一測',
  audioVoice:"有聲音",
  regionTitle:"由於版權限制，您所在的地區無法瀏覽該內容。",
  regionTitleAudio:"由於版權限制，您所在的地區無法聆聽該内容。",
  regionTitleBook:"由於版權限制，您所在的地區無法閱讀該内容。",
  regionTitleBuy:"由於版權限制，您所在的地區無法購買該内容。",
  relLink:"相關內容",
  downloading:"下載中",
  viewAll: "查看全部 >",
  topicStr1:"「悅讀越好，悅聽越美」",
  topicStr2:"聯合出版集團抗疫公益文化活動",
  text_open:"查看全部",
  text_close:"收起",
  time_hour:"小時",
  buyReset: '重新支付',
  buyBook: "書架",
  buyTips1: "請使用瀏覽器中打開當前頁面",
}

export const SPEAKER_LANG = '講者'
export const AUTHOR_LANG = '作者'
export const PRICE_UNIT_LANG = 'HK$'
// export const PRICE_UNIT_LANG = '知書幣'
export const FREE_LANG = '免費'
export const DETAILS_LANG = "詳情"
export const MORE_LANG = "更多"
export const COURSE_LANG = {
  course: {
    preview: '試聽',
    read: '試閱',
    immediatelyRead: '立即閱讀',
    courseCount: ['共', '課時', '集'],
    isBuy: '已購買',
    buy: '立即購買',
    exchange: '立即兌換'
  }
}




/**
 * 公共提示字段
 */

export const REQUEST_ERR_LANG_1 = '請求失敗'
export const REQUEST_ERR_LANG_2 = '獲取用戶信息失敗'
export const REQUEST_ERR_LANG_3 = '加載數據失敗'
export const REQUEST_ERR_LANG_4 = '缺少參數'
export const REQUEST_ERR_LANG_5 = '請求失敗,請稍候再試'
export const REQUEST_ERR_LANG_6 = '数据出错,请稍后再试'
export const REQUEST_ERR_LANG_7 = '系统出错,请稍后再试'
export const PLAYADDRESS_ERR_LANG = '獲取播放地址失敗'

export const receive_btn = '立即領取'
export const LOADING = '正在加載...'


// 首頁
export const INDEX_LANG = {
  topTitle: "知書",
  menu: ['講書', '開課', '有聲書', '電子書', '視頻'],
  search: {
    placeholder: '搜尋',
    title: '必須輸入'
  },
  talkbook: {
    title: '名家講書',
  },
  course: {
    title: '精品課程',
    courseCount: ['共', '課時'],
    isBuy: '已購買'
  },
  audioBook: {
    title: '有聲閱讀'
  },
  video: {
    title: '免費賞'
  },
  ebook: {
    title: '電子書'
  },
  vipCar: {
    carTitle: '知書會員卡',
    title: '知書會員'
  },

  content: {
    title: "新手大禮包",
    description: "恭喜獲得新手大禮包",
    content: "（優惠券、送幣、免費内容）"
  },
  umengObj: "首頁",
  userDo: ["觀看", "聆聽"],
  backHome: "返回首頁"
}

//講書列表頁
export const SAYINGBOOK_LANG = {
  listTitle: ['最新', '名家', 'AI導讀', '推薦'],
  page: ["講书", "講書欄目頁"]
}

//開課列表頁
export const STARTCOURSE_LANG = {

  listTitle: ['精品課', '大師課', '生活課', '學經典', '職場課', '公開課'],
  page: "開課"
}

//聲書列表頁
export const AUDIOBOOK_LANG = {
  listTitle: ['最新', '推薦', 'AI快讀', '兒童', '吟誦', '經典'],
  page: "有聲書"
}

//電子書列表頁
export const EBOOK_LANG = {
  topTitle: "電子書",
  listTitle: ['香港專題', '精選', '倪匡專區', '類型小說', '親子', '世界名著'],
  page: [
    "電子書",
    "有聲書欄目頁",
    "分類"
  ]
}

//電子書分類頁
export const EBOOKLIST_LANG = {
  topTitle: "電子書分類",
  book: "圖書",
  ce: "冊",
  none: "暫無內容"
}

//電子書引導頁
export const EBOOKGUIDE_LANG = {
  text: ["會員免費閱讀", "活動免費領取", "會員免費領取"]
}

//視頻列表页
export const VIDEOLIST_LANG = {
  listTitle: ['訪談', '導賞', '寫經典'],
  video: "視頻"

}

//買書頁
export const BUYBOOK_LANG = {
  name: '《果殺中宇宙》',
  btnText: '購買即可閱讀完全文'
}

//電子書詳情頁
export const EBOOKDETAIL_LANG = {
  columnName: '電子書',
  read: '試閱',
  column: "欄目",
  limitedTimeShopping: "限時閃購",
  limitedTimeShoppings: "限時閃購價",
  freeForMembers: "會員免費",
  umengText: [
    "我聽過的書",
    "我讀過的書",
    "我學過的課程",
  ],
  paperBook: [
    "講書",
    "開課",
    "有聲書",
    "電子書",
    "視頻",
    "查看詳情",
  ],
  description: "詳情頁",
}

// 專欄頁面
export const DETAIL_LANG = {
  buyNumber: '人已購買',
  previewNumber: '人已聆聽',
  buyBook: '購書',
  commentTitle: '留言',
  preview: '試聽',
}

// 目錄組件
export const CATALOG_LANG = {
  title: '目錄',
  audioNumber: '個音頻',
  dialogMessage: '該內容需要購買才可播放',
  confirmText: '立刻購買',
  noPreview: '本專輯不支持試閱',
  text: ["個視頻", "個音頻"]
}

//評論組件
export const COMMENT_LANG = {
  comment: '評論',
  noComment: '暫無留言',
  delectText: '刪除',
  reply: '回複',
  dialogMessage: '是否刪除該評論',
  confirmText: '確定',
  textareaText: '請輸入內容',
  showToastNull: '請填寫留言內容',
  showToastSuccess: '留言成功',
  showToastFail: '留言失敗',
  cancelLike: '已取消點贊',
  likeSuccess: '點贊成功'
}

//buyBar 組件
export const BUYBAR_LANG = {
  buy: "立刻購買",
  currency: '個幣',
  speak: '講',
  buySuccess: '購買成功',
  orderDetail: '訂單詳情',
}

//forget頁面
export const FORGET_LANG = {
  email: '電\u2003郵',
  inputEmail: '請輸入電郵',
  code: '驗證碼',
  inputCode: '請輸入驗證碼',
  second: '秒可重發',
  getCode: '獲取驗證碼',
  pass: '新密碼',
  inputPass: '請輸入你的新密碼',
  inputPassTwo: '請再次輸入你的新密碼',
  inputPassThree: '請輸入密碼',
  inputPassFour: '請再次輸入密碼',
  passMessage: '密碼必須爲英文與數字組合',
  confirm: '確認',
  confirmPass: '確認密碼',
  emailNullErr: '請輸入電郵地址',
  emailErr: '電郵地址格式不正確',
  sendCode: '驗證碼已經發送到你電郵,請註意查收',
  getCodeErr: '獲取驗證碼錯誤',
  CodeErr: '驗證碼格式不正確',
  twoPassErr: '兩次輸入不一致',
  resetPassSuccess: '重置密碼成功',
  resetPassFail: '重置密碼失敗',
}

//login 登录頁面
export const LOGIN_LANG = {
  inputYouEmail: '請輸入你的電郵',
  email: '電\u2003郵',
  inputYouPass: '請輸入密碼',
  pass: '密\u2003碼',
  forGetPass: '忘記密碼',
  phoneLogin: '使用手機號碼註冊/登入',
  youPhone: '請輸入你的手機號碼',
  phone: '手\u2003\u2002機',
  code: '驗證碼',
  second: '秒可重發',
  getCode: '獲取驗證碼',
  emailLogin: '電郵登入/註冊',
  doLogin: '立即登入',
  doLoginTwo: '登入',
  reg: '註冊',
  thirdLogin: '第三方註冊登入',
  userSee: ['如要繼續即表示您同意並接受「知書」的', '私隱聲明', '及', '使用條款和細則'],
  newUserSee: "《知書隱私條款》",
  newUserSeeRule: ["本人已閱讀並同意知書之", "隱私條款", "本人希望接收知書的最新資訊及優惠"],
  newUserSeeToast: "請先勾選隱私條款",
  area: ['中國大陸 +86', '香港(中國) +852', '澳門(中國) +853', ],
  allowSuccess: '授權成功，需要綁定郵箱，即將跳轉',
  allowSuccessTwo: '授權成功，即將跳轉',
  allowSuccessThree: '授權成功',
  allow: '請求授權中',
  err: '失敗',
  phoneNull: '手機號碼不能爲空',
  phoneErr: '請輸入正確的手機號碼',
  sendCodeSuccess: '驗證碼發送成功',
  sendCodeErr: '驗證碼獲取失敗',
  inputCode: '請輸入驗證碼',
  codeErr: '請輸入四位數驗證碼',
  loginErr: '登入失敗',
  emailNullErr: '請輸入電郵地址',
  emailErr: '電郵格式不正確',
  soFast: "發送頻率太快，稍後再試",
  orangeNewsLogin: "使用橙新聞帳號去購買",
}

//register 注冊頁
export const REGISTER_LANG = {

  inputYouPass: '請輸入你的密碼',
  inputYouPassTwo: '請再次輸入你的密碼',
  appellation: '稱謂',
  inputAppellation: '請輸入你的稱謂',
  appellationMessage: '由2-12個中英文字母、數字 、 “-” 、“_” 組成',
  inputAppellationTwo: '請輸入稱謂',
  appellationMinLength: '請輸入兩個以上字符',
  appellationMaxLength: '請輸入的字符超過12個',
  appellationErr: '稱謂包含特殊字符',
  regSuccess: '註冊成功',
  regFail: '註冊失敗',
}


//注冊成功頁
export const REGISTER_SUCCESS_LANG = {
  regSuccess: '註冊成功！',
  text: [
    '恭喜成爲知書會員',
    '盡享會員專有優惠,敬請關註',
    '知書會員',
  ],
  modify: '稍後修改',
  modifyData: '修改個人資料',
  getUserDataErr: '獲取用戶信息失敗',
  isNotice: "本人希望獲取知書的最新通訊及優惠",
  btnText: "確定",
  popText: "是否不再接受最新通訊及優惠公告"
}

//搜索页
export const SEARCH_LANG = {
  topTitle: "搜尋",
  inputTexas: '請輸入要搜尋的詞語(不少於兩個字)',
  search: '搜尋',
  heatSearch: '熱搜:',
  searchMessage: '暫無搜尋內容',
  searchErr: '搜尋關鍵詞失敗，請重試'
}

//分類搜尋
export const SEARCHCATALOG_LANG = {
  topTitle: "分類搜尋",
}

// purchase 页
export const PURCHASE_LANG = {
  menu: ['講書', '課程', '有聲書', '電子書'],
  readBook: [
    '個音頻', '已聽', '未聽', '已聽完'
  ],
  course: [
    '節課', '已聽', '未聽', '已聽完'
  ],
  audioBook: [
    '作者', '朗讀', '最近更新', '音頻', '已聽', '未聽', '已聽完'
  ],
  eBook: [
    '已讀至', '未觀看'
  ],
  loginState: [
    '登入後同步已購內容',
    '去登入'
  ],
  expire_buy_message: '內容已失效，如需繼續閱讀/聆聽，請重新購買。',
}

// list 组件
export const LIST_LANG = {
  title: '還沒有任何內容',
  buyTitle: '還沒有購買任何內容',
  btnText: '去發現',
  surplus: "剩餘",
  soldOut: "已售罄",
  buyAtOnce: "立刻購買",
  isBuy: "已購買"
}

// me頁
export const ME_LANG = {
  goToLogin: '去登錄',
  learningTime: '學習時間',
  getLearningTime: '獲取用戶學習時間失敗',
  afterLoginShow: '登錄後顯示',
  readBook: '看過的書',
  hearCourse: '聽過的課',
  hearBook: '聽過的書',
  member: '知書會員',
  dowmLocal: '離線閱讀',
  setting: '設置',
  tipsLogin: '登入可查看！',
  level: [
    // '基本會員',
    '知書會員',
    '折扣會員',
    '超級會員',
    '至尊會員',
  ],
  coupon: "優惠券",
  recordsOfConsumption: "消費記錄"
}

// 電箱綁定
export const BINDEMAIL_LENG = {
  bindSuccess: '電箱綁定成功',
  bindFail: '綁定失敗',
}

//手機綁定
export const BINDPHONE_LANG = {
  phone: '手機號碼',
  sendCode: '發送驗證碼',
  sendingCode: '正在發送驗證碼',
  alreadySendingCode: '驗證碼已發送到你手機',
  sendCodeEmail: '發送驗證碼到郵箱',
  noReceived: '沒有收到？',
  resend: '重新發送',
  sendTime: '發送時間不能小于60秒',
  inputPhone: '請輸入手機號',
  phoneNumberErr: '手機號碼必須爲數字',
  macaoPhoneErr: '請輸入正確的8位數手機號碼',
  zhPhoneErr: '請輸入正確的11位數手機號碼',
  phoneErr: '請輸入正確的8位數手機號碼',
  phoneInputErr: '請輸入正確的手機號碼',
  inputCode: '請輸入收到的驗證碼',
  codeSend: '驗證碼已發送',
  bindSuccess: '手機號綁定成功，1秒返後回',
}

// collection 頁
export const COLLECTION_LANG = {
  audioNumber: '個音頻',
  courseNumber: '節課',
  collectionTab: [{
      name: "講書",
      code: "talk_book"
    },
    {
      name: "開課",
      code: "course"
    },
    {
      name: "有聲書",
      code: "audio"
    },
    {
      name: "電子書",
      code: "ebook"
    },
    {
      name: "視頻",
      code: "video"
    }
  ]
}

//historyRecord_audio 頁 historyRecord_course 頁 historyRecord_ebook 頁
export const HISTORYYRECORDAUDIO_LANG = {
  audioBookMsg: '紙質書',
  hearBook: [
    '已聽完', '已聽'
  ],
  hearCourse: [
    '已聽完', '已聽', '節課'
  ],
  noComment: '還沒有任何內容',
  goToFind: '去發現',
  feedbackErr: '反饋失敗！，請稍後再試'
}

//nickName   頁
export const NICKNAME_LANG = {
  inputAppellation: '請輸入你的新稱謂',
  appellation: '稱謂',
  appellationMessage: '由2-12個中英文字母、數字 、 “-” 、“_” 組成',
  save: '保存',
  saveSuccess: '保存成功！',
  saveFail: '保存失敗！'
}

// personal 页
export const PERSONAL_LANG = {
  user: [
    '頭像', '稱謂', '電郵', '手機帳號'
  ],
  bingText: [
    '更換綁定', '去綁定'
  ],
  uploadPortrait: '頭像上傳中',
  uploadPortraitSuccess: '更新頭像成功',
  uploadPortraitFail: '更新頭像失敗',
  uploadPhotoFail: '圖片上傳錯誤',
  err: '發生錯誤',
  getPhotoFail: '獲取圖片簽名失敗',
  getUserDataFail: '獲取用戶信息失敗',
  invitationCode: "邀請碼",
  member: "至尊會員",
  personalData: "個人資料"
}

//vip 頁
export const VIP_LANG = {
  text: [
    '尊敬的知書會員',
    '盡享會員專有優惠，敬請關註！',
    '知書會員',
    '修改會員資料'
  ]
}

// buy 頁
export const BUY_LANG = {
  price: '價格',
  myMoney: '我的餘額',
  underpayment: '不足支付',
  increment: '增值',
  text: '你將購買商品為虛擬內容服務，購買後不支持退訂、轉讓、退換，請在確認購買之前仔細閱讀購物條款及細則；購買後可在已購區查看和使用',
  count: '統計',
  confirmPay: '確認支付',
  getGoodsDataFail: '獲取銷售商品數據失敗',
  getUsersAccountDataFail: '獲取賬戶餘額失敗',
  balanceErr: '餘額不足，請增值',
  buyFail: '購買失敗！',
  limitedTimeSpike: "限時閃購價",
  packagePrice: "套裝價格",
  member: "會員",
  buyingAdvice: {
    title: "購買建議",
    text: "不參加活動，使用優惠券購買更優惠"
  },
  promotion: "該內容正在促銷",
  memberCollection: "會員免費領取",
  useBtn: "參加活動",
  bought: "已購買",
  buy: "購買",
  integralFail: '積分不足',
  availableIntegral: '可用',
}

//buySuccess 頁
export const BUYSUCCESS_LANG = {
  text: [
    '購買成功！',
    '訂單號',
    '立刻查看',
    '訂單詳情',
    '産品',
    '實際支付'
  ],
}

//recharge 頁
export const RECHARGE_LANG = {
  surplus: '剩餘',
  increment: '立刻增值',
  incrementT: '充值卡',
  howToPay: '如何付款',
  dialogText: [
    '您尚未登入',
    '去登入',
    '僅在本設備增值'
  ],
  getIncrement: '正在獲取增值結果',
  errPayMes: '支付方式暫未開放，敬請期待',
  incrementSuccess: '增值成功',
  androidMes: '增值說明：知書幣餘額僅限 Android 系統消費，無法在其他系統使用。',
  isoMes: '增值說明：知書幣餘額僅限 iOS 系統消費，無法在其他系統使用。',
  give: "贈",
  native: ["增值紀錄", "知書幣查詢"],
  payPalName: "知書幣增值",
  text: ["個"],
  input: "請輸入充值卡卡號",
  selectPay: {
    0: "知書增值",
    1: "知書幣",
    2: "選擇支付方式",
    3: "支付寶HK",
    4: "微信支付",
    5: "信用卡支付",
    6: "谷歌支付",
    7: "華為支付",
  }


}

//rechargeList 頁
export const RECHARGELIST_LANG = {
  title: "暫無增值記錄",
  text: ["增值：", "知書幣", "贈送", "個知書幣"]
}

//rechargeSuccess 頁
export const RECHARGESUCCESS_LANG = {
  text: [
    '增值成功！',
    '現有知書幣',
    '個',
    '確定',
  ],
  record: "增值記錄"
}

//comment 组件
export const COMMENTPAGE_LANG = {
  commentTitle: [
    '精選', '全部'
  ],
  inputComment: '寫評論',
}

//audioPlayer 组件

export const AUDIOPLAYER_LANG = {
  preview: '試聽',
  buyBook: '購書',
  dialogText: [
    '該內容需要購買才可播放',
    '立即購買'
  ],
  playAddressErr: '獲取播放地址錯誤',
  firstContent: '這是第一個內容',
  lastContent: '這是最後一個內容',
  playErr: '播放發生錯誤'
}

//audioPlayer[Deprecated] 组件

export const AUDIOPLAYERDE_LANG = {
  shwoDialog: [
    '提示', '需要購買才能解鎖收聽', '立即購買', '取消'
  ],
  shwoDialogEnd: [
    '提示', '需要購買才能解鎖收聽', '立即購買', '取消'
  ],
  shwoDialogLogin: [
    '提示', '需要登入后才能購買', '立即登入', '取消'
  ],
  showDialogLoginEnd: [
    '提示', '未登入，需要登入購買才能解鎖收聽', '立即登入', '取消'
  ],
  showOrangeDialogLoginEnd: [
    '提示', '购买后才可解锁收听', '立即购买', '取消'
  ]
}

//audioStopSet 組件

export const AUDIOSTOPSET_LANG = {
  time: '倒計時',
  switch: '關閉',
  listData: [{
      title: "不開啓",
      flag: true,
      show: true
    },
    {
      title: "播完當前聲音",
      flag: false,
      show: true
    },
    {
      title: "播完2集聲音",
      flag: false,
      show: true
    },
    {
      title: "播完3集聲音",
      flag: false,
      show: true
    },
    {
      title: "10分鐘後",
      flag: false,
      show: true
    },
    {
      title: "20分鐘後",
      flag: false,
      show: true
    },
    {
      title: "30分鐘後",
      flag: false,
      show: true
    }
  ]
}

// dialog 組件

export const DIAlOG_LANG = {
  listText: [
    '未登入狀態下增值會有以下限制：',
    '1.增值知書幣及購買記錄無法轉移到其他帳號，僅限本設備可用',
    '2.APP卸載後增值知書幣無法找回'
  ]
}

//relBook 页
export const RELBOOK_LANG = {
  relBook: '相關推薦',
  text: ['視頻', '紙本書', '電子書'],
  changeCode: ["講書", "開課", "有聲書", "電子書", "視頻", "查看詳情"],
  err: "獲取播放地址失敗",
  showToast: "該服務由超閱網提供",
  showToast1: "該服務由一本提供",
  showToast2: "即將前往外部連結",
}

// searchBlock 组件
export const SEARCHBLOCK_LANG = {
  text: '查看更多搜尋結果'
}

// about 页

export const ABOUT_LANG = {
  text: {
    0: '知書 · 關於',
    1: '「知書」是全港第一個以「聽」為主的閱讀移動平台，集讀、聽、看、學於一身。「知書」旨在滿足當下都市人對閱讀「快速」、「有趣」、「品味」的需求，隨時隨地為他們提供精準的知識服務。讀者可根據自己不同的時間狀態來選擇知識的媒體；除了傳統的閱讀，還可以聽書、聽課程,每個人可根據各自的習慣來選擇閱讀模式，無縫隙地讓閱讀走入大家的生活。內容主要是以音頻、視頻、文字等呈現閱讀的多種場景，當中以「聽書」為核心功能。',
    2: '知書版本：',
  }
}

//advertising 页

export const ADVERTISING_LANG = {
  text: {
    0: '知書 · 廣告合作',
    1: '以集讀、聽、看、學於一身的「知書」，連結百多萬香港人的知識服務平台。為配合人們閱讀習慣的轉變，我們正在探索新形態的圖書出版和流通模式。',
    2: '年齡在18-45歲之間的人群是主要使用新媒體的受眾，同時也是需要不斷自我增值及學習的階段，「知書」是本港首個知識服務類平台，利用豐富的作者資源和內容優勢，透過多樣態的知識內容，提供快速、實用、有趣的資訊，配合實用輕巧的課程為主打，同時利用當下熱點作為內容包裝，引起年青一代關註，大受讀者及廣告客戶歡迎。',
    3: '網上媒體廣告效益有增無減，手機應用程式不受時間及地域限制，令讀者能更便捷地接收知識，「知書」為廣告客戶提供個性化宣傳方案，透過一站式及多元化的營銷方案，幫助客戶尋求新潛在客戶，以擴大客戶基礎。'
  }
}

//feedBack 頁

export const FEEDBACK_LANG = {
  opinion: '請提出您寶貴的意見：',
  youPhoneOrEMail: '您的郵箱或者手機號：',
  inputOpinion: '請填寫反饋內容',
  inputContactMode: '請填寫聯系方式',
  confirmErr: '操作頻繁，請兩分鍾後再提交',
  confirmSuccess: '反饋成功',
  confirmFail: '反饋失敗！請稍後再試'
}

//setting 页

export const SETTING_LANG = {
  list: {
    0: '用户ID：',
    1: '意見反饋',
    2: '應用評分',
    3: '語言設置',
    4: '關於',
    5: '幫助中心',
    6: '廣告合作',
    7: '隱私政策',
    8: '知書服務使用條款',
    9: '清除本地數據緩存',
    10: '退出登入',
    11: '開發者工具',
    12: ["消息推送設置(點擊開啟)", "消息推送設置(點擊關閉)"],
    13: '切換至繁體',
    14: '切換至簡體',
  },
  dataDelect: '本地緩存數據已全部清除！',
}



//help 页

export const HELP_LANG = {
  text: {
    0: '知書 · 幫助中心',
    1: '- 帳號問題 ',
    2: '1. 如何註冊並登入知書APP？',
    3: '目前註冊知書APP需以有效的電郵、電話或第三方平台作為綁定。成功註冊後，在每次登入時可選擇「電郵驗證碼」或「賬號密碼」兩種方式進行身份驗證。',
    4: '2. 如何在知書APP綁定（取消綁定）電郵？',
    5: '在APP右下角「我」，右上角齒輪「設置」，點擊「賬號綁定設置」即可進行設定。',
    6: '3. 可否註銷我的賬戶?',
    7: '目前知書APP沒有註銷功能，如確實需要註銷全部個人資料，請與我們的客戶服務人員聯繫。nowbookinfo@suep.com',
    8: '4. 如何更改密碼？',
    9: '在個人設置頁面，點擊「更改密碼」即可。過程需要提供電郵驗證碼作為身份驗證。',
    10: '5. 忘記密碼怎麼辦？',
    11: '如已登入請先登出賬號，在登入介面下方點擊「找回密碼」即可。如忘記註冊所用的電郵地址，請與我們的客戶服務人員聯繫。',
    12: '- 增值問題',
    13: '1. 為什麼必須增值？',
    14: '知書APP內的付費內容，均為自由定價型虛擬商品，虛擬商品必須通過增值完成消費。',
    15: '2. 知書幣可用於購買哪些商品？',
    16: '知書幣餘額可用於購買APP內虛擬商品，如講書、課程、有聲書、電子書等。',
    17: '3. 知書幣可以退款或提現嗎？',
    18: '知書幣餘額為增值後用戶虛擬商品消費的虛擬幣，增值後的餘額不會過期，但無法提現或轉增。',
    19: '在支付前請仔細核對支付賬號及支付金額，以便後續順利使用。',
    20: '4. 增值後為何沒有即時到賬？',
    21: '知書APP的增值服務由第三方支付平台完成，如果存在增值問題，請與我們的客服聯繫。客戶服務電郵：nowbookinfo@suep.com',
    22: '請提供支付記錄、憑證之截圖，並提供正確的客戶註冊電郵地址。查明核實後，我們會盡快助你完成增值並處理問題',
    23: '- 購買問題',
    24: '1. 知書APP有什麼商品？',
    25: '知書APP持續製作大量與書有關的精美音頻、課程、電子書等內容，建議你經常打開APP並在「發現」頁探索最新的優質內容。',
    26: '2. 知書APP會員如何在線下實體書店享受折扣優惠？',
    27: '知書會員於香港全線三聯書店、中華書局、商務印書館實體店享有購書優惠。於收銀台結賬時，只需打開知書APP，登入後於「發現」頁點擊右上角的「會員卡」圖標，會顯示二維碼。將此二維碼提供給收銀工作人員即可享受優惠。',
    28: '. 虛擬商品是否存在使用期限？',
    29: '知書APP內的全部虛擬內容無使用期限。',
    30: '4. 我的知書幣是否會過期？',
    31: '知書幣為虛擬幣，增值後的餘額不會過期，但無法提現或轉贈他人。',
    32: '5. 購買了虛擬商品，可否退換？',
    33: '知書APP內的所有付費內容，均為自由定價型虛擬商品，不支持退換。',
    34: '在購買、支付時，請務必清楚購買內容及使用期限。如遇到特殊異常問題無需緊張，請與我們的客戶服務人員聯繫，我們會第一時間為你提供幫助。',
    35: '6. 購買的內容無法查看、使用，怎麼辦？',
    36: '遇到使用異常，請先確認網絡是否通暢、連接正常。',
    37: '如無法解決問題，請保留錯誤提示或出現異常的頁面的截圖，並與我們的客戶服務人員聯繫，我們會盡快為你處理。',
    38: '- 頁面問題',
    39: '1. 網絡正常，為何一些頁面卻刷新緩慢甚至無法打開？',
    40: '即使在網絡良好的情況下，APP服務器的連接也會有可能存在短暫的斷開，因此會導致頁面無法正常顯示。',
    41: '建議可以退出當前頁面，或徹底關閉APP並再次打開。如仍然無法打開，請檢查數據網絡、WIFI服務的狀態是否正常。',
    42: '2. 查看內容時，圖片文字顯示異常？',
    43: '與上述情況類似，顯示異常可能與網絡連接有關。請退出當前頁面或關閉APP，並重新進入嘗試。',
    44: '3. 異常問題持續，如何解決？',
    45: '請保留出問題的頁面或錯誤提示，並與我們的客戶服務人員聯繫。',
    46: '- 音頻問題',
    47: '1. 播放時出現異常停頓，加載時間過長？',
    48: '音頻加載與手機內存，網絡情況都有關係。如果多次出現加載問題，請嘗試退出APP並重新打開。或嘗試在手機設置中，清理知書APP的緩存檔。',
    49: '2. 為何點擊播放卻沒有反應？',
    50: '請先確定當前網絡連接正常，或嘗試退出當前頁面，並重新進入點擊。如問題仍然存在，請保留當前頁面截圖並與客戶服務人員聯繫。',
    51: '3. 知書APP的內容可以下載嗎？',
    52: '知書APP的全部虛擬內容受版權保護，因此所有聲音檔案不支持下載內容，只有電子書可以離線下載，但不可下載到APP以外的地方。在播放頁面，你可以點擊下載按鈕對有興趣的內容進行「緩存」，以便在網絡不理想的情況下流暢閱讀。',
  }
}

// policy 页

export const POLICY_LANG = {
  title: "知書隱私條款",
  text: {
    1: '知書 · 隱私政策',
    2: '生效日期： 2015年7月1日',
    3: '請註意我們可能對此聲明作出更正修改而不作預先通知。請閣下定時查閱',
    4: '在本私隱聲明內，「個人資料」指任何與以下有關的資料：',
    5: '(甲) 直接或間接與一名在世的個人有關的；',
    6: '(乙) 可以切實地從該資料直接或間接地確定有關的個人的身份；',
    7: '(丙) 該資料的存在形式令予以查閱及處理均是切實可行的。',
    8: '1. 私隱政策',
    9: '1.1 服務承諾',
    10: '為致力保障個人資料的私隱權，本公司確保在收集、使用、保留、轉移及查閱個人資料方面的政策及常規，均符合香港法例第486章個人資料（私隱）條例的規定（「條例」）。本公司只會根據條例及此私隱聲明收集、使用或披露個人資料。',
    11: '1.1.1 Cookies',
    12: '在使用我們APP（包括流動服務）之時，除非另有說明，否則本公司只會記下閣下曾經到訪，而不會收集任何可辨識個人身份的資料（即關於閣下及可用於辨識閣下身份的資料）。我們的APP任何部分所使用的Cookies（如有），並非用於收集可辨識個人身份的資料。Cookies是細小的電腦檔案，可儲存於上網人士的電腦內，用於獲取配置資料以及分析上網人士的瀏覽習慣。Cookies可免除閣下每次瀏覽APP時重新登記的麻煩，並通常用於追蹤閣下喜歡選擇的網頁主題。閣下如不希望接受Cookies，可以修改有關互聯網選項或閣下電腦系統的瀏覽選項，但閣下可能因此無法使用或啟動本APP的若干功能。',

    13: '1.1.2 我們收集閣下的哪些個人資料',
    1301: '閣下或須不時提供可辨識閣下個人資料，包括但不限於閣下的姓名、性別、出生日期、國籍、電話號碼、傳真號碼、郵寄地址、電郵地址、信用卡資料、銀行戶口號碼、教育程度、職業、家庭收入、個人收入、婚姻狀況及興趣 （「個人資料」）。 ',
    1302: '在閣下使用我們的產品及/或服務時，我們需要/可能需要收集和使用的閣下的個人資訊包括如下兩種：',
    1303: '1、為實現向閣下提供我們產品及/或服務的基本功能，閣下須授權我們收集、使用的必要的資訊。如閣下拒絕提供相應資訊，閣下將無法正常使用我們的產品及/或服務；',
    1304: '2、為實現向閣下提供我們產品及/或服務的附加功能，閣下可選擇授權我們收集、使用的資訊。如閣下拒絕提供，閣下將無法正常使用相關附加功能或無法達到我們擬達到的功能效果，但並不會影響你閣下正常使用我們產品及/或服務的基本功能。',
    1305: '如閣下未滿十八歲，必須先得到家長或監護人的同意，方可向本公司提供任何個人資料。',
    1306: '在使用閣下授權的第三方廠商登入時提供的用戶憑證，個人頭像，昵稱，郵箱基本資訊。',
    14: '1.1.3 我們如何共享，轉讓公開閣下的個人資料',
    1401: '1.1.3.1 事先獲得閣下的聲明或授權',
    1402: '1.1.3.2 遵循當地法律法規或政府要求。',
    1403: '1.1.3.3 解决欺詐，安全問題，保證我們及閣下的合法權益。',
    1404: '1.1.3.4 我們可能會與我們關聯的集團公司和合作夥伴共享資訊，包含不僅限於帳戶資訊，訂單資訊，位置資訊和設備資訊，在共享這些資訊時我們會再次徵求閣下的同意。',
    1405: '1.1.3.5 本公司發生了資產合併、收購、重組或出售等情况。',
    15: '1.1.4 我們收集閣下個人資料的用途',
    1501: '本公司從閣下收集的個人資料會因收集資料的情况而定，閣下的個人資料大概會用於：',
    1502: '1.1.4.1 閣下授權提供給本公司的用途；',
    1503: '1.1.4.2 與閣下提供給本公司直接有關的用途；',
    1504: '1.1.4.3 任何閣下已授權同意的用途。',
    1505: '1.1.4.4 我們收集閣下的電話號碼，電郵地址，協力廠商登入憑證用於完成本軟件帳戶的登錄註冊，以保證本軟體功能的正常使用。',
    1506: '1.1.4.5 我們使用我們收集的資訊來提供運營和服務。 我們還使用我們收集的資訊來改進本軟件和為閣下提供個性化服務，以便閣下在使用本軟件時獲得更好的體驗。',
    1507: '1.1.4.6 我們使用閣下與我們共享或我們收集的資訊來進行研究、調查、產品測試和故障排除，以幫助我們運營和改進我們的產品和服務。',
    16: '1.1.5 個人資料的保存',
    1601: '閣下與本公司進行業務往來之時，本公司將保存閣下的網上交易紀錄以作稽核之用。 本公司的一般政策是將有關資料保存一段合理時間。 按照我們的內部政策，這些紀錄之後會從我們的系統中被删除。',
    17: '1.1.6 查閱及更正資料',
    1701: '根據有關條例，閣下有權：',
    1702: '1.1.6.1 查核本公司是否持有閣下任何個人資料；',
    1703: '1.1.6.2 查閱本公司持有閣下的個人資料；',
    1704: '1.1.6.3 要求本公司更正任何不正確的個人資料；',
    1705: '1.1.6.4 確定本公司就個人資料（不時）採取的政策及常規，以及本公司持有的個人資料之類別。',
    18: '1.1.7 如何删除個人資料和帳戶資訊',
    1801: '如確實需要註銷帳戶及删除全部個人資料，請與我們的客戶服務人員聯系。',
    1802: '如欲查閱、更正個人資料，或索取有關政策和常規以及本公司所持個人資料類別的資料，或删除個人資料和帳戶資訊，請以下列途徑提出要求：',
    1803: '郵寄：香港九龍長沙灣永康街77號環薈中心10樓1011室「知書」客戶服務部主管 收',
    1804: '電郵： nowbookinfo@suep.com',
    1805: '星期一至五 早上9時至晚上6時; 星期六、日及公眾假期休息',

    34: '1.1.8 保安',
    35: '本公司會採取所有實際可行的步驟，以保障閣下的個人資料，免受未經授權人士查閱、處理、刪除、損毁或使用有關資料。',
    36: '為保證個人資料的凖確性、同時避免未經授權取用個人資料和確保個人資料的正確使用，我們實施了適當的實體、技術、管理措施防範和保障我們所收集的個人資料。',
    37: '爲進一步保障特定個人資料，閣下須輸入閣下的個人用戶名稱和密碼以進入閣下的「知書會員」帳戶。',
    38: '2. 個人資料收集聲明',
    39: '閣下作為知書及/或我們的APP的瀏覽者或會員或顧客，在向本公司申請及/或繼續使用本公司服務及／或產品時，可能需要向本公司提供閣下的個人資料。倘有關個人資料並不完整或不正確，本公司可能無法向閣下提供或繼續提供有關服務。',
    40: '本公司時刻將閣下的個人資料保密處理。本公司有關收集、使用、保存、披露、轉移、保密及查閱個人資料的政策及常規，均符合條例規定，並已載於本私隱聲明內。',
    41: '2.1 使用及保存',
    42: '本公司可使用及保存你提供的個人資料，以配合以下用途和閣下與本公司可能同意或法律不時要求的其他用途：',
    43: '2.1.1 處理閣下的會員申請；',
    44: '2.1.2 在閣下同意的情況下，使用閣下的個人資料（包括：姓名、性別、出生日期、國籍、電話號碼、傳真號碼、住址、電郵地址、教育程度、職業、婚姻狀況、興趣、最喜歡的活動和購買行為） 推銷、推廣及客戶管理我們、我們的聯營公司、合作伙伴之服務及/或產品。我們會以直銷電話、SMS、MMS、電郵、電子訊息、跨平台通訊應用程式（如：手機通訊應用）、手機應用程式、傳真﹑郵件、社交媒體等方式向閣下提供有關推廣資料;',
    45: '2.1.3 服務的正常管理、運作及保養;',
    46: '2.1.4 設計我們、我們的APP及聯營公司供閣下使用而提供的新服務，或改善現有服務;',
    47: '2.1.5 調查投訴、備受懷疑的可疑交易及研究服務改善措施;',
    48: '2.1.6 防止及偵測罪行;',
    49: '2.1.7 根據法例作出披露。',
    50: '2.2 披露及轉移',
    51: '在收集閣下的個人資料之前，本公司會在相關的個人資料收集聲明中通知閣下有關資料將會向第三者披露。閣下的個人資料大概會用於：',
    52: '(甲) 閣下提供給本公司的用途；',
    53: '(乙) 與閣下提供給本公司直接有關的用途；',
    54: '(丙) 任何閣下已同意的用途。',
    55: '我們可向（不論在香港或海外）下列各方披露及轉移閣下的個人資料，並可就以上目的使用、披露、處理或保存閣下的個人資料：',
    56: '2.2.1 我們的代理及承辦商（包括資訊技術、網絡、客戶服務、銷售代理及承辦商）、任何電訊公司及服務供應商就提供有關服務；',
    57: '2.2.2 銀行、財務機構及信貸供應商；',
    58: '2.2.3 追收欠款公司、信用調查機構及保安代理；',
    59: '2.2.4 規管當局、執法機構及法院；',
    60: '2.2.5 我們的專業顧問；',
    61: '2.2.6 任何實際或建議承讓或受讓我們與閣下相關權利的承讓人或受讓人。',
    62: '經閣下同意，本公司可能會以其他方式使用及披露閣下的個人資料。除非在特殊情況下，本公司可能需要按法律要求或批准的情況下，披露有關的個人資料，如提供予執法機構或阻止嚴重威脅公眾安全的事宜。',
    63: '2.3 直接促銷',
    64: '本公司會用收集所得的個人資料，向閣下傳送宣傳品及推廣優惠或作其他促銷的用途，但本公司會遵從條例內有關直接促銷的規定。',
    65: '如果本公司打算將閣下的個人資料用作直接促銷或轉交第三者(不論是否獲得金錢或其他財產的回報)作直接促銷的用途，則本公司會於收集閣下的個人資料之前，在相關的個人資料收集聲明中通知閣下，本公司會向閣下提供拒絕接受直接促銷的機會。如若閣下不欲接收有關直接促銷通訊或資料，請登入知書賬戶，然後在「更改個人資料」的頁面取消選取「我同意知書按私隱政策聲明使用我的個人資料作直接促銷」。',
    66: '假如閣下當時沒有拒絕接受直接促銷，但及後決定不擬接受直接促銷，或不希望我們披露、轉移或使用閣下的個人資料作上述直接促銷用途，閣下可透過下列途徑提出要求：',
    67: '郵寄：香港九龍長沙灣永康街77號環薈中心10樓1011室「知書」客戶服務部主管 收',
    68: '電郵： nowbookinfo@suep.com',
    69: '星期一至五 早上9時至晚上6時; 星期六、日及公眾假期休息',
    70: '我們會於收到你的要求後40天內作出相關的資料更新，惟此資料更新將不會影響於更新前本公司將閣下的個人資料用作直接促銷或已轉交第三者作直接促銷用途的任何責任。 閣下必須提供相關申請所要求必須填寫的個人資料，否則本公司將無法處理閣下的相關申請。'
  }
}


//userTerms 页
export const USERTERMS_LANG = {
  text: {
    0: '《知書服務使用條款》',
    1: '請您（以下亦稱「用戶」）仔細閱讀本協議全部條款，並確認您已完全了解本協議之規定。如果您對本協議的任何條款錶示異議，您可以選擇不註冊知書用戶。當您註冊成功，使用知書服務，或在知書上發佈任何內容均意味著您完全接受本協議各項條款的約束。',
    2: '一、使用規則',
    3: '1、用戶註冊成功後，知書將給予每個用戶一個用戶帳號及相應的密碼，該使用者帳號和密碼由使用者負責保管；用戶應當對以其用戶帳號進行的所有活動和事件負法律責任。',
    4: '2、使用者須對在知書的註冊資料的真實性、合法性、有效性承擔全部責任，使用者不得冒充他人；不得利用他人的名義發佈任何資訊；不得惡意使用註冊帳號導緻其他用戶誤認，否則知書有權立即停止提供服務，收回其帳號並由用戶獨自承擔由此而産生的一切法律責任。',
    5: '3、用戶註冊帳號應符合中華人民共和國香港特別行政區法律法規的要求，不得註冊侵害他人權益、不符合社會道德規範的用戶名，對於知書認為不恰當的用戶帳戶，知書有權不經通告進行封停。',
    6: '4、使用者直接或通過各類方式間接使用知書服務和資料的行為，都將被視作已無條件接受本協定全部內容；若使用者對本協議的任何條款存在異議，請停止使用知書所提供的全部服務。',
    7: ' 5、知書是一個內容發佈、分享、傳播及獲取的平臺，用戶通過知書發錶的資訊為公開信息，其他第三方均可以通過知書獲取使用者發錶的資訊，使用者對任何資訊的發錶即認可該資訊為公開信息，並單獨對此行為承擔法律責任；任何使用者不願被其他第三人獲知的資訊都不應該在知書上進行發錶。',
    8: '6、使用者承諾不得以任何方式利用知書直接或間接從事違反香港法律以及社會公德的行為，知書有權對違反上述承諾的內容予以刪除。',
    9: '7、使用者不得利用知書服務製作、上載、複製、發佈、傳播或者轉載如下內容：',
    10: '（1）違反憲法及基本法所確定的基本原則的；',
    11: '（2）危害國家安全，泄露國家秘密，顛覆國家政權，破壞國家統一的；',
    12: '（3）損害國家榮譽和利益的；',
    13: '（4）煽動民族仇恨、民族歧視，破壞民族團結的；',
    14: '（5）破壞國家宗教政策，宣揚邪教和封建迷信的；',
    15: '（7）散佈淫穢、色情、賭博、暴力、兇殺、恐怖或者教唆犯罪的；',
    16: '（8）侮辱或者誹謗他人，侵害他人合法權益的；',
    17: '（9）含有法律、行政法規禁止的其他內容的資訊。',
    18: '8、知書有權對使用者使用情況進行審查和監督，如用戶在使用知書時違反任何上述規定，知書或其授權的人有權要求用戶改正或直接採取一切必要的措施（包括但不限於更改或刪除使用者張貼的內容、暫停或終止使用者使用知書的權利）以減輕用戶不當行為造成的影響。',
    19: '9、用戶在知書平臺增值的讀幣應用於消費知書平臺上的付費內容，知書不對此提供提現服務。',
    20: '二、知識産權',
    21: '知書是一個內容發佈、獲取、分享及傳播的平臺，我們尊重和鼓勵使用者創作的內容，認識到保護知識産權對知書生存與發展的重要性，承諾將保護知識産權作為知書運營的基本原則之一。',
    22: '1、 使用者在知書上發錶的全部原創內容（包括但不僅限於文章、評論和提問），著作權均歸用戶本人所有。使用者可授權第三方以任何方式使用，不需要得到知書的同意。',
    23: '2、 知書的文字、圖片、音訊、視頻等版權均歸知書享有或與作者共同享有，未經許可，不得任意轉載。',
    24: ' 3、知書提供的網路服務中包含的標識、版麵設計、排版方式、文本、圖片、圖形、音訊、視頻等均受著作權、商標權及其它法律保護，未經相關權利人同意，上述內容均不得在任何平臺被直接或間接發佈、使用、出於發佈或使用目的的改寫或再發行，或被用於其他任何商業目的。',
    25: '4、為了促進知識的分享和傳播，用戶將其在知書上發錶的全部內容，授予知書免費的、不可撤銷的、非獨家使用許可，知書有權將該內容用於知書各種形態的産品和服務上，包括但不限於網站、臉書、微信以及發錶的應用或其他互聯網産品。',
    26: '5、第三方若出於非商業目的，將使用者在知書上發錶的內容轉載到知書之外的地方，應當在作品的正文開頭的顯著位置註明原作者姓名（或原作者在知書上使用的帳號名稱），給出原始連結，註明「發錶於知書」，並不得對作品進行修改演繹。若需要對作品進行修改，或用於商業目的，第三方應當聯係使用者獲得單獨授權，按照使用者規定的方式使用該內容。',
    27: '6、在知書上傳或發錶的內容，使用者應保證其為著作權人或已取得合法授權，並且該內容不會侵犯任何第三方的合法權益。如果第三方提出關於著作權的異議，知書有權根據實際情況刪除相關的內容，且有權追究使用者的法律責任。給知書或任何第三方造成損失的，用戶應負責全額賠償。',
    28: '7、如果任何第三方侵犯了知書用戶相關的權利，用戶同意授權知書或其指定的代理人代錶知書自身或用戶對該第三方提出警告、投訴、發起行政執法、訴訟、進行上訴，或談判和解，並且用戶同意在知書認為必要的情況下參與共同維權。',
    29: '8、知書有權但無義務對使用者發佈的內容進行審核，有權根據相關證據結合《侵權責任法》、《資訊網路傳播權保護條例》等法律法規對侵權資訊進行處理。',
    30: '三、侵權舉報',
    31: '知書作為內容發佈和知識服務社區，高度重視自由錶達和個人、企業正當權利的平衡。依照法律規定刪除違法資訊是知書的法定義務。',
    32: '1、受理範圍',
    33: '受理知書平臺內侵犯企業或個人合法權益的侵權舉報，包括但不限於涉及個人隱私、造謠與誹謗、商業侵權。',
    34: '（1）涉及個人隱私：發佈內容中直接涉及身份資訊，如個人姓名、家庭住址、身份證號碼、工作單位、私人電話等詳細個人隱私；',
    35: '（2）造謠、誹謗：發佈內容中指名道姓（包括自然人和企業）的直接謾駡、侮辱、虛構中傷、惡意誹謗等；',
    36: '（3）商業侵權：洩露企業商業機密及其他根據保密協定不能公開討論的內容。',
    37: ' 2、舉報條件',
    38: '使用者在知書發錶的內容僅錶明其個人的立場和觀點，並不代錶知書的立場或觀點。如果個人或企業發現知書上存在侵犯自身合法權益的內容，可以先嘗試與作者取得聯係，通過溝通協商解決問題。如您無法聯係到作者，或無法通過與作者溝通解決問題，您可通過聯係知書平臺進行投訴。為了保證問題能夠及時有效地處理，請務必提交真實有效、完整清晰的材料，否則投訴將無法受理。您需要嚮知書提供的投訴材料包括：',
    39: '（1）權利人對涉嫌侵權內容擁有商標權、著作權和/或其他依法可以行使權利的權屬證明，權屬證明通常是營業執照或組織機構代碼證；',
    40: '（2）舉報人的身份證明；',
    41: '（3）如果舉報人非權利人，請舉報人提供代錶權利人進行舉報的書麵授權證明。',
    42: '為確保投訴材料的真實性，在侵權舉報中，您還需要簽署以下法律聲明：',
    43: '我本人為所舉報內容的合法權利人，我舉報的發佈在知書上的內容侵犯了本人相應的合法權益，如果本侵權舉報內容不完全屬實，本人將承擔由此産生的一切法律責任，並承擔和賠償知書因根據投訴人的通知書對相關帳號的處理而造成的任何損失，包括但不限於知書因嚮被投訴方賠償而産生的損失及知書名譽、商譽損害等。',
    44: '3、處理流程',
    45: '（1）出於網路平臺的監督屬性，並非所有申請都必須受理。知書自收到舉報的七個工作日內處理完畢並給出回複。處理期間，不提供任何電話、郵件及其他方式的查詢服務。',
    46: '（2）出現知書已經刪除或處理的內容，但是百度、穀歌等搜尋引擎依然可以搜尋到的現象，是因為百度、穀歌等搜尋引擎自帶緩存，此類問題知書無權也無法處理，因此相關申請不予受理。您可以自行聯係搜尋引擎服務商進行處理。',
    47: '（3）用戶在知書中的商業行為引發的法律糾紛，由交易雙方自行處理，與知書無關。',
    48: '四、免責聲明',
    49: '1、因駭客行為或用戶的保管疏忽導緻用戶帳號非法使用，知書不承擔任何責任。',
    50: '2、知書不對使用者發錶的內容或評論的正確性進行保證。',
    51: '3、使用者明確同意其使用知書網路服務所存在的風險及一切後果將完全由用戶本人承擔，知書對此不承擔任何責任。',
    52: '4、使用者在知書發錶的內容僅錶明其個人的立場和觀點，並不代錶知書的立場或觀點。作為內容的發錶者，需自行對所發錶內容負責，因所發錶內容引發的一切糾紛，由該內容的發錶者承擔全部法律及連帶責任，知書不承擔任何法律及連帶責任。',
    53: '5、知書不保證網路服務一定能滿足使用者的要求，也不保證網路服務不會中斷，對網路服務的及時性、安全性、準確性也都不作保證。',
    54: '6、對於因不可抗力或不能控製的原因造成的網路服務中斷或其它缺陷，知書不承擔任何責任，但將盡力減少因此而給用戶造成的損失和影響。',
    55: '五、協議修改',
    56: '1、根據互聯網的發展和有關法律、法規及規範性檔的變化，或者因業務發展需要，知書有權對本協議的條款作出修改或變更，一旦本協定的內容發生變動，無論通知與否，知書對用戶和任何第三人均無需承擔任何責任。',
    57: '2、如果不同意知書對本協議相關條款所做的修改，用戶有權並應當停止使用知書。如果用戶繼續使用知書，則視為使用者接受知書對本協議相關條款所做的修改。',
    58: '六、附則',
    59: ' 1、本協議的訂立、執行和解釋及爭議的解決均應適用中華人民共和國香港特別行政區法律。',
    60: '2、如本協議中的任何條款無論因何種原因完全或部分無效或不具有執行力，本協議的其餘條款仍應有效並且有約束力。',
    61: '3、本協議解釋權及修訂權歸聯合電子出版有限公司所有。',
  }
}

//sign 模塊
export const SING_LANG = {
  descri: ['簽到禮包', '連續簽到天數', '天', '獲得禮包', '個', '簽到規則', '每位用戶連續簽到則積分遞增，若簽到中斷，則從新開始計算'],
  singGifts: [
    '簽到獎賞',
    '規則說明',
    '1.領取成功後，請到“我的-優惠券”中查看;',
    '2.可在商品中兌換或者商品下單時使用;',
    '3.新客首單優惠券不與其他優惠券叠加;',
    '4.使用優惠券時下單手機號碼必須為搶禮包時手機號碼;',
    '5.如有其他疑問請質詢知書客服。'
  ],
  singPopup: ['簽到成功！', '連續簽滿', '恭喜獲得禮包', '簽到禮包'],
  calendar: ['連續簽到', '總禮包', '個', '簽到日曆', '可補簽', '簽到規則 >'],
  receiveGifts: ['免費', '立刻領取會員大禮包', '立刻領取'],
  coin: "知書幣",
  text: ['今日已簽',
    '連續簽到即可獲得知書禮包1份',
    '未啟動',
    '簽到活動正在籌備中，敬請期待',
    '號',
    '簽到可獲得知書禮包1份',
    '期間簽到，每天可獲得知書禮包壹份',
    '簽到可獲得知書禮包壹份'
  ],
  lists: {
    0: '1、每天登入知書即視為簽到成功；',
    1: '2、每名用戶每天只可簽到一次；',
    2: '3、每連續登入3天，即可獲神秘禮包一份；',
    3: '4、若連續簽到中斷，則重新計算天數；',
    4: '5、簽到情況每月1號重新計算；',
    5: '6、最終解釋權歸知書所有。'
  }
}

//receiveGifts 页
export const RECEIVEGIFTS_LANG = {
  freeCoupon: "免費券",
  props: {
    btn: {
      default: "立刻領取會員大禮包",
      text: "關閉"
    }
  },
  text: ["免費", "近期暫無禮包，敬請期待！", "立刻領取會員大禮包", '請到"我的"查看', "查看我的禮券", "已領取會員大禮包"],
  popMsg: "領取成功",
}

// getCoupon 页
export const GETCOUPON_LANG = {
  itemsText: "張優惠券",
  btn: "立刻領取優惠券",
  popup: {
    text: "你可以在知書-優惠券查看",
    item: ["免費券", "優惠券"]
  }
}

//shareCoupon 页
export const SHARECOUPON_LANG = {
  domText: ["贈送", "張優惠券"],
  btn: "分享優惠券"
}

//giftPackDetail 页
export const GIFTPACKDETAIL_LANG = {
  text: {
    0: "規則說明",
    1: "1.領取成功后，请到“我的-優惠券”中查看;",
    2: "2.可在商品中兌換或者商品下單時使用;",
    3: "3.新客首單優惠券不與其他優惠券叠加;",
    4: "4.使用優惠券時下單手機號碼必須為搶禮包時手機號碼;",
    5: "5.如有其他疑問請質詢知書客服。"
  }
}

//coupon available 组件
export const COUPONAVAILABLE_LANG = {
  // coupon: "暫無可用優惠券",
  coupon: "優惠券",
  Nocoupon: "暫無可用優惠券",
  btn: "確認"
}
export const ORDERAVAILABLE_LANG = {
  coupon: "優惠",
  Nocoupon: "暫無可用優惠",
  btn: "確認"
}
//coupon button 组件
export const COUPONBUTTON_LANG = {
  btn: "確認",
  errBtn: "重新輸入",
  receive: {
    success: "領取成功",
    fail: "領取失敗"
  }
}

//coupon details 组件
export const COUPONDETAILS_LANG = {
  userText: "此按鈕店員點擊",
  instructionsForUse: "使用說明",
  change: "換一換",
  goPage: "去發現頁使用",
  bought: "商品已購買了",
  showToast: [
    "最多選擇",
    "個",
    "優惠券信息錯誤",
    "請選擇兌換内容",
  ],
  exchange: {
    success: "恭喜，兌換成功！",
    errText: "抱歉，兌換失敗！",
    errMsg: "商品已經購買過",
  },
  use: {
    sucBtn: "返回優惠券頁",
    errText: "抱歉，使用失敗！",
    isUse: "該券已使用",
    backBtn: "返回優惠券",
  },
  cardDescription: "優惠券詳情",
  cardTitle: "主題卡詳情",
}

//coupon List 组件
export const COUPONLIST_LANG = {
  text: [
    "免費券",
    "沒有優惠券"
  ]
}

//coupon Popup 组件
export const COUPONPOPUP_LANG = {
  text: [
    "請到已購頁查看",
    "恭喜你，獲得一張",
    "免費券",
    "確認領取",
  ],
  errBtn: "重新輸入",
  errText: "抱歉，兌換失敗！",
  sucText: "恭喜，兌換成功！",
}

//coupon Tab 组件
export const COUPONTAB_LANG = {
  expired: "已過期"
}

// receiveCoupon 页
export const RECEIVECOUPON_LANG = {
  itemsText: "張優惠券",
  btn: "立刻領取優惠券",
  popup: {
    text: "你可以在知書-優惠券查看",
    item: ["免費券", "優惠券"]
  },
  couponType: '現金券'
}

// coupon 页
export const COUPON_LANG = {
  text: "兌換優惠券",
  excAll: "全部兌換",
  timeStr1:"兌換有效期：",
  timeStr2:"内容有效期：",
}

// coupon exchange 页
export const COUPONEXCHANGE_LANG = {
  text: [
    "VIP特權會員提供貴賓使用",
    "可免費無限享有知書內任意產品",
    "請輸入您的兌換碼",
    "享受折扣優惠，請兌換後返回購買"
  ],
}

// marketing activityBlock 页
export const ACTIVITYBLOCK_LANG = {
  timeText: {
    start: "距開始剩餘",
    end: "距結束剩餘"
  },
  endOfActivity: "本次活動已經結束",
  title: "爲你精選",
  btn: ["點擊查看", "立刻搶購"],
  nullData: '活動即將開始，敬請期待'
}

//marketing block 页
export const MARKETINGBLOCK_LANG = {
  flashSale: "限時閃購",
  qualityRecommendation: "精品推薦",
  chooseForYou: "爲你精選",
  clickToView: "點擊查看"
}

//marketing detail 页
export const MARKETINGDETAIL_LANG = {
  text: [
    "人購買", "簡介"
  ]
}
//marketing salesList 页
export const SALESLIST_LANG = {
  text: [
    "限量精選，火熱搶購中",
    "距開始剩餘",
    "距結束剩餘",
    "本次活動已經結束",
  ],
  flashSale: "限時閃購",
  qualityRecommendation: "精品推薦",
  participate: "我參與了",
  activity: "活動",
  activityJoin: "活動，你也趕緊加入吧",
}

//contents 页
export const CONTENTS_LANG = {
  text: [
    "套裝組合詳情",
    "本電子書",
    "個音頻",
    "個視頻",
    "本書籍",
  ]
}


//marketing activityList 页
export const ACTIVITYLIST_LANG = {
  flashSale: "限時閃購",
  qualityRecommendation: "精品推薦",
  participate: "我參與了",
  activity: "活動",
  activityJoin: "活動，你也趕緊加入吧",
  promotion: "促銷"
}

//member areaList 页
export const AREALIST_LANG = {
  text: [
    "換一換", "暫無", "內容"
  ],
  btnText: {
    nextBtn: "下一頁",
    topBtn: "上一頁"
  },
  type: ["有聲書", "電子書", "視頻", "開課", "講書"]
}

//member count 页
export const COUNT_LANG = {
  text: [
    "12個月累計金額",
    "費",
    "會員",
    "升級為",
    "續會",
    "如欲繼續享受會員優惠,只需在有效期内消費滿",
    "便可自動續會",
    "消費記錄",
    "會員優惠"
  ]
}

//member popup 页
export const MEMBERPOPUP_LANG = {
  text: [
    "領取失敗",
    "領取成功",
    "認證失敗",
    "認證成功",
  ],
  btnText: ["確定", "關閉"]
}

//member userCard
export const USERCARD_LANG = {
  text: [
    "會員卡號：",
    "費",
    "級為",
    "知書會員",
    "錢讀更好的書",
    "登入",
    "立刻註冊"
  ]
}

// member vipVardSwiper
export const MEMBERSWIPER_LANG = {
  text: [
    "未開啓",
    "會籍有效期：",
    "消費金額",
    "會員等級"
  ]
}

//member welfareNav 頁
export const WELFARENAV_LANG = {
  nav: [
    "專享折扣",
    "專享免費產品",
    "會員禮包"
  ],
  title: "會員福利"
}

//record 頁
export const RECORD_LANG = {
  text: [
    "累計消費金額",
    "知書",
    "詳情",
    "還沒有任何消費記錄",
    "欄目消費"
  ],
  nav: [{
    name: "知書APP內消費"
  }, {
    name: "門店消費"
  }]
}

//supremeMember 頁
export const SUPREMEMEMBER_LANG = {
  text: [
    "至尊會員供貴賓使用",
    "可免費無限享有知書APP内任意產品",
    "請輸入您的至尊會員碼",
  ],
  btn: [
    "確認"
  ]
}


// disount 頁
export const DISOUNT_LANG = {
  text: [
    "專享優惠",
    "會員級別",
    "全線三聯書店、中華書局或商務印書館門市",
    "精選貨品9折優惠",
    "所有產品9折",
    "精選貨品8折優惠",
    "所有產品8折",
    "知書App内"
  ]
}

//free_goods 頁
export const FREEGOODS_LANG = {
  text: ["專享內容"]
}

//memberArea 頁
export const MEMEBERAREA_LANG = {
  nav: [
    "會員詳情",
    "會員卡",
    "優惠券",
    "消費記錄"
  ],
  title: [
    "會員免費",
    "會員折扣"
  ]
}


//memberFift 頁
export const MEMBERGIFT_LANG = {
  memberGifts: [
    '會員禮包',
    '規則說明',
    '1、領取成功後，請到「我的—優惠券」中查看;',
    '2、優惠券可在商品中兌換或者商品下單時使用;',
    '3、請於指定日期前使用，過期無效;',
    '4、迎新優惠券不得與其他優惠券同時使用;',
    '5、如有其他疑問，請咨詢知書客服;',
    '使用範圍：',
    '近期暫無禮包，敬請期待！',
    '立刻領取會員大禮包',
    '立刻領取簽到大禮包',
    '領取成功',
    '前往我的優惠券使用',
    '使用説明',
    '本券可用於兌換知書APP上指定的內容',
    '1張免費券只能兌換1個內容',
    '請在有效期內使用，逾期作廢',
    '天後過期',
    '領取后',
    '6、活動最終解釋權歸知書所有。'
  ],
}

////memberInfo 頁
export const MEMBERINFO_LANG = {
  text: ["會籍詳情"]
}

//memberDetails頁
export const MEMBERDETAILS_LANG = {
  text: [
    "會員級別、升降級條件以及續會條件",
    "級別名稱",
    "級別條件",
    "註冊即成為基本會員",
    "12個月累計消費",
    "自動續會",
    "累計消費",
    "基本會員升級:",
    "基本會員於過去24個月內累積消費$1500-4999,即可自動升級至折扣會員；而累積消費達$5000,即可自動升級至超級會員",
    "折扣會員升級:",
    "折扣會員於過去36個月內累積消費$5000,即可自動升級至超級會員",
    "超級會員及折扣會員只要消費滿指定金額，即可自動續會；如未達指定消費金額，將於下個月1號調整會員級別",
    "續會條件",
    "級別名稱",
    "級別條件",
    "註冊即成為基本會員",
    "續會條件",
    "APP內享有折扣",
    "無",
    "產品",
    "全缐三聯書店、中華書店、商務印書舘門市享有折扣",
    "精選產品",
    "",
  ]
}

// news 頁
export const NEWS_LANG = {
  text: [
    "知書",
    "詳情",
    "評論回復",
    "暫無消息",
    "個人",
    "優惠資訊與公告",
  ],
  err: '設置失敗',
  success: '設置成功',
  popupText: ['請開啟推送通知', '以第一時間接收消息推送', '立刻開啓', '是否願意接收最新消息推送', '確定']
}

//message頁
export const MESSAGE = {
  text: "請先開啟消息推送"
}
// publicize頁
export const PUBLICIZE_LANG = {
  text: ["即將前往外部網站"]
}

//codeCard 頁
export const CODECARD_LANG = {
  text: [
    "於門店消費時掃描",
    "QRCode賺取消費積分",
    "消費滿指定金額，即享門市折扣優惠",
    "會籍狀況",
    "會員優惠"
  ],
  card: "知書會員",
  grade: ['知書會員', '至尊會員']
}

//search
export const SEARCH = {
  text: [
    "暫無內容",
    // "搜尋電子書類別裏面的書籍",
    // "搜尋有聲書類別裏面的專輯",
    // "搜尋講書類別裏面的專輯",
    // "搜尋開課類別裏面的專輯",
    // "搜尋視頻類別裏面的內容",
    // "搜尋專輯或者書籍",
    "搜尋內容",
  ]
}

//androidRecharge 頁
export const ANDRECHARDE_LANG = {
  err: "運行異常"
}


export const UTILS_LANG = {
  lang0: "普通話",
  lang1: "廣東話",
  lang2: "英語",
}


// 離線閱讀頁
export const EPUBLOCALLIST_LANG = {
  code: {
    status1: '等待下載',
    status2: '獲取下載地址',
    status3: '預下載失敗',
    status4: '正在下載',
    status6: '下載失敗',
    status8: '文件解壓失敗',
    status9: '已下載',
    status100: '位置錯誤',
  },
  dele: '刪除',
  retry: '重新下載',
  retryTip: '正在重新下載',
  noUserId: '登入後才能下載',
  noFree: '此電子書已過會員免費期，請購買閱讀'
}

//網絡判斷彈窗
export const NETWORKTIPS_LANG = {
  message: '當前無wifi，是否允許使用流量播放',
  confirmText: '總是允許',
  cancelText: '允許本次',
  // utils.js
}


export const down_JS = {
  noParameter: '缺少參數',
  status1: '等待下載',
  status2: '獲取下載地址',
  status3: '獲取地址失敗',
  status5: '下載成功',
  status6: '下載失敗，請重新下載',
  status7: '解壓中',
  status8: '解壓失敗，請重新下載',
  status11: '文件已經存在下载隊列，請重試',
  status12: '所有任務下載完成',
  status100: '未知錯誤',
}


export const epubLocalList = {
  text: "還沒有下載的電子書"
}


export const DISCOUNT_LANG = {
  text: [
    "在知書App內注冊，即可成為知書會員，可享有會員折扣及優惠權益。",
    "會員權益說明",
    "專屬會員折扣",
    "註冊成為知書會員，購買App內各欄目的內容可不定期享有折扣優惠。",
    "會員免費專區",
    "每月更新。知書會員每月可享受一批指定免費內容閱讀或收聽。",
    "會員折扣專區",
    "每月更新。知書會員在折扣專區購買產品，可享有不同折扣優惠。",
    "會員禮包",
    "每月可領取價值不等的會員福利禮包，包括內容免費券、現金券、折扣券等。",
  ]
}

export const PALY_LANG = {
  text: ["倍速播放", "播放設置"]
}

export const ALI_LANG = {
  text: {
    0: "你正在使用支付寶進行知書幣增值",
    1: "知書幣",
    2: "姓 (LastName)",
    3: "名 (FirstName)",
    4: "請輸入你的手機號碼",
    5: "請輸入你的郵箱",
    6: "請輸入姓",
    7: "請輸入名",
    8: "請輸入手機號碼",
    9: "請輸入郵箱",
    10: "不可為空",
  }
}
export const LOAD_END = {
  text: "沒有更多了"
}

//通用文字
export const COMMON_TEXT = {
  confirmText: '確定',
  cancelText: '取消',
  confirmBuyText: '立即購買',
  buyText: '該內容需要購買才可繼續閱讀',
  loadingText: '加載中...',
  pageText: '頁',
  annotation: '註',
  cataLog: '目錄'
}

//个人中心公告说明
export const EXPLAINH5 = {
  title: '溫馨提示',
  text : '綁定手機號或郵箱，解鎖更多功能，如閱讀記錄、劃線筆記等，更多優惠信息，請下載“知書”APP進行使用。',
  contact1 : '如有任何疑問，可咨詢知書客服：' ,
  contact2 : 'WhatsApp：63682411' ,
  contact3 : 'E-mail：nowbookinfo@suep.com' ,
  contact4 : 'WeChat：ZhiShu315' ,
  contact5 : '電話：2597 8414' 
}



// WEBPACK FOOTER //
// ./src/common/lang/tw.js